module.exports = __webpack_public_path__ + "img/9788949120836.b3416357.jpg";